<template>
  <div class="week-picker">
    <div class="desc-label">{{ descLabel }}</div>
    <div class="picker">
      <date-pick
        ref="datepicker"
        v-model="value"
        @input="handleInput"
        :inputAttributes="{ readonly: true }"
        :format="'MM/DD/YYYY'"
        :isDateDisabled="isFutureDate"
      ></date-pick>
      <img src="../../assets/icons/calendar.svg" alt="" />
    </div>
  </div>
</template>

<script>
import DatePick from 'vue-date-pick'
import { parse, format, getDay, subDays, addDays, startOfDay } from 'date-fns'
export default {
  name: 'WeekPicker',
  components: {
    DatePick
  },
  props: {
    descLabel: {
      required: true,
      type: String
    },
    name: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.setupRange(startOfDay(new Date()))
  },
  data() {
    return {
      value: null,
      range: {
        startDate: null,
        endDate: null,
      }
    }
  },
  methods: {
    handleInput(e) {
      const currentDate = parse(e, 'MM/dd/yyyy', new Date())
      this.setupRange(currentDate)
    },
    getStartOfWeek(date) {
      const currentWeekDay = getDay(date)
      return subDays(date, currentWeekDay - 1)
    },
    getEndOfWeek(date) {
      const currentWeekDay = getDay(date)
      return addDays(date, 7 - currentWeekDay)
    },
    setupRange(currentDate) {
      const startOfWeek = this.getStartOfWeek(currentDate)
      const endOfWeek = this.getEndOfWeek(currentDate)
      this.value = `${format(startOfWeek, 'MM/dd/yyyy')} - ${format(
        endOfWeek,
        'MM/dd/yyyy'
      )}`
      this.range.startDate = startOfWeek
      this.range.endDate = addDays(endOfWeek, 1)
      this.$emit('setWeek', {
        name: this.name,
        range: this.range,
        string: this.value
      })
    },
    isFutureDate(date) {
      return date > this.getEndOfWeek(new Date())
    }
  }
}
</script>

<style lang="scss" scoped>
.picker {
  position: relative;

  img {
    position: absolute;
    top: 50%;
    right: 12px;
    width: 20px;
    height: auto;
    transform: translateY(-50%);
    pointer-events: none;
  }
}
.desc-label {
  margin-bottom: 5px;
  font-size: 14px;
  color: $text-secondary;
}
</style>
